// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 1fr;\n  grid-template-columns: 1fr 1fr;\n}\n.footer__body,\n.footer__body a {\n  color: #444;\n  font-size: 14px;\n  font-weight: 300;\n  font-family: \"Roboto\", Arial, sans-serif;\n}\n.footer__body {\n  margin-top: 30px;\n  padding-top: 10px;\n  border-top: 1px solid #ccc;\n}\n.footer__body + .footer__body {\n  text-align: right;\n}\n.footer__body a:hover {\n  color: deeppink;\n}", ""]);
// Exports
module.exports = exports;
